// Package Imports
import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Authenticated } from '@refinedev/core';
import {
  CatchAllNavigate,
  NavigateToResource,
} from '@refinedev/react-router-v6';
import { ThemedLayoutV2 } from '@refinedev/antd';

// Project Imports
import DashboardRoute from 'core/routes/DashboardRoute';
import ErrorRoute from 'core/routes/ErrorRoute';
import LoginRoute from 'core/routes/LoginRoute';
import Header from 'components/header';
import RegisterRoute from 'core/routes/Register';
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import CustomSider from 'components/sider/sider';
import CommunicationHubRoute from 'core/routes/CommunicationHubRoute';
import ProfileRoute from 'core/routes/ProfileRoute';
import NudgeConfigurationRoute from 'core/routes/NudgeConfigurationRoute';
import AudienceGroupingRoute from 'core/routes/AudienceGroupingRoute';

const AppRoutes: React.FC = () => (
  <Routes>
    <Route
      element={
        <Authenticated fallback={<CatchAllNavigate to={routeName.login} />}>
          <ThemedLayoutV2
            Header={() => <Header />}
            Sider={() => <CustomSider />}
          >
            <Outlet />
          </ThemedLayoutV2>
        </Authenticated>
      }
    >
      <Route
        index
        element={<NavigateToResource resource={resourceName.dashboard} />}
      />
      {DashboardRoute}
      {AudienceGroupingRoute}
      {CommunicationHubRoute}
      {ProfileRoute}
      {NudgeConfigurationRoute}
    </Route>
    {ErrorRoute}
    {RegisterRoute}
    <Route
      element={
        <Authenticated fallback={<Outlet />}>
          <NavigateToResource />
        </Authenticated>
      }
    >
      {LoginRoute}
    </Route>
  </Routes>
);

export default AppRoutes;
